export const getMinutes = function (m) {
  return Number(m.minute) + Number(m.hour) * 60;
};

// converts time reperested in strings like '2000' to object with details
export const getTimeDetailes = (time) => {
  let adaptedTime = {};
  let timeArray = time.split('');
  adaptedTime.hour = Number(`${timeArray[0]}${timeArray[1]}`);
  adaptedTime.minute = Number(
    `${timeArray[timeArray.length - 2]}${timeArray[timeArray.length - 1]}`
  );

  return adaptedTime;
};

export const convertMinutesToTimeObj = (minutes) => {
  const hour = Math.floor(minutes / 60);
  const min = minutes % 60;

  return { min, hour };
};

// converts time as minutes to time string. for example 480 minutes to '0800'
export const convertMinutesToTimeString = (minutes) => {
  const { min, hour } = convertMinutesToTimeObj(minutes);

  return String(hour).padStart(2, '0') + String(min).padStart(2, '0');
};
